import {$} from './jquery-definition.js';

$( function() {
	$( '.adjacent' ).prev().addClass( 'adjacent-next' );
} );

$( window ).on( 'resize', function() {
} );


$( document ).on( 'scroll', function() {
} );

